export const nl = {
  AlleenstaandeOuderenkorting: "Alleenstaande ouderenkorting",
  AndereGezinsleden: "Andere gezinsleden",
  BerekendeVerdragsbijdrage: "Berekende verdragsbijdrage",
  BrutoMaandbedrag: "Bruto maandbedrag",
  BrutoMaandbedragPensioenUitkering: "Bruto maandbedrag pensioen/uitkering",
  BrutoMaandbedragOverigInkomen: "Bruto maandbedrag overig inkomen",
  BrutoMaandbedragInfo: "Tel al uw overige maandelijkse inkomsten bij elkaar op",
  DateValidationFactoryValidationText: "U heeft in het invulveld '{{label}}' geen juiste datum ingevuld.",
  DateNotInFutureValidationFactoryText:
    "U heeft in het invulveld '{{label}}' geen juiste datum ingevuld. Deze mag niet in de toekomst liggen.",
  DateNotInRangeValidationFactoryText:
    "U heeft in het invulveld '{{label}}' geen juiste datum ingevuld. Vul een datum in vanaf 01-01-{{minYear}} tot 31-12-{{maxYear}}.",
  FoutTijdensUitvoerenBerekening: "Fout tijdens uitvoeren berekening. Probeer het later opnieuw.",
  GeboorteDatum: "Geboortedatum",
  GeboortedatumPartner: "Geboortedatum partner",
  GeboortedatumVanUwPartner: "Geboortedatum van uw partner (dd-mm-jjjj)",
  GezinsledenMeeverzekerdInfo:
    "Bijvoorbeeld inwonende kinderen van 18 jaar en ouder die met u meeverzekerd zijn via het CAK.",
  HeeftUEenPartnerZonderEigenInkomen: "Heeft u een partner zonder eigen inkomen?",
  Ingangsdatum: "Ingangsdatum (dd-mm-jjjj)",
  IngangsdatumOverigInkomen: "Ingangsdatum (dd-mm-jjjj) overig inkomen",
  IngangsdatumInfo: "Vanaf welke datum bent u in dit te berekenen jaar verzekerd via het CAK?",
  IngangsdatumMeeverzekeringGezinsleden: "Ingangsdatum meeverzekering gezinsleden",
  IngangsdatumPensioenOfUitkering: "Ingangsdatum pensioen of uitkering (dd-mm-jjjj)",
  IngangsdatumVerdragsbijdrage: "Ingangsdatum verdragsbijdrage",
  InkomensafhankelijkeZvwBijdrage: "Inkomensafhankelijke Zvw-bijdrage",
  InkomensafhankelijkeWlzBijdrageMinHeffingskorting:
    "Inkomensafhankelijke Wlz-bijdrage (minus heffingskortingen)",
  IsRequiredValidationFactoryValidationText: "U heeft het invulveld '{{label}}' niet ingevuld.",
  IsBedragValidationFactoryValidationText: "U heeft het invulveld '{{label}}' niet juist ingevuld.",
  KiesEenLand: "Kies een land",
  KiesEenUitkering: "Kies een uitkering",
  MaximumNumberValidationText:
    "U heeft in het invulveld '{{label}}' een bedrag ingevuld dat groter is dan {{maximumBedrag}}.",
  MeeverzekerdGezinslid: "Meeverzekerd gezinslid (dd-mm-jjjj)",
  NietverdienendePartnerKorting: "Niet-verdienende partner korting",
  NominaleBijdrage: "Nominale bijdrage",
  OverzichtVerdragsbijdrage: "Overzicht verdragsbijdrage",
  OverigInkomen: "Overig inkomen",
  OverigInkomenValidatieMelding:
    "Als u overig inkomen heeft ontvangen, voert u zowel het bedrag als de ingangsdatum in. Heeft u geen overig inkomen ontvangen? Laat dan deze velden leeg.",
  Partner: "Partner",
  PartnerMeeverzekeren: "Partner meeverzekeren",
  PartnerVanafWelkeDatumMeeverzekerd: "Partner vanaf welke datum meeverzekerd  (dd-mm-jjjj)",
  RekenhulpVerdragsBijdrage: "Rekenhulp verdragsbijdrage",
  RekenhulpVerdragsBijdrageIntroText:
    "U kunt uw bijdrage over één kalenderjaar laten uitrekenen. U vult zelf een ingangsdatum in, maar de einddatum is altijd 31 december. Wilt u een tweede jaar berekenen, dan moet u de rekenhulp nog een keer invullen.",
  StapCategoriePersoonlijkeGegevens: "Persoonlijke gegevens",
  StapCategorieInkomensGegevens: "Inkomensgegevens",
  StapCategorieOverzicht: "Overzicht",
  StapCategorieUitkomst: "Uitkomst",
  SoortPensioenOfUitkering: "Soort pensioen of uitkering",
  SubtotaalPremieExclusiefWoonlandfactor: "Subtotaal premie exclusief woonlandfactor",
  TerugNaarStart: "Klik hier om opnieuw te beginnen",
  Uitkomst: "Uitkomst",
  UwGeboorteDatum: "Uw geboortedatum  (dd-mm-jjjj)",
  UwWoonland: "Uw woonland?",
  VanafWelkeDatumIsUwGezinslidMeeverzekerd: "Vanaf welke datum is uw gezinslid meeverzekerd (dd-mm-jjjj)?",
  VolgendGezinslid: "Volgend gezinslid",
  WettelijkPensioenOfUitkering: "Wettelijk pensioen of uitkering",
  Woonland: "Woonland",
  Woonlandfactor: "Woonlandfactor",
  ZijnErNogAndereGezinsledenMeeverzekerd: "Zijn er nog andere gezinsleden van 18 jaar en ouder meeverzekerd?",
  GeneriekePageIntroText:
    "U kunt uw bijdrage over 1 kalenderjaar uitrekenen. Dit kan voor de jaren {{proefBerekeningActiveYearsFrom}} tot en met {{proefBerekeningActiveYearsTo}}. U vult zelf de ingangsdatum in, de einddatum is altijd 31 december. Het bedrag dat uit de berekening komt, is een totaalbedrag voor dat jaar (dus geen maandbedrag). Houd er rekening mee dat de berekening een schatting is. U kunt er geen rechten aan ontlenen.",
  StartNieuweBerekening: " Start nieuwe berekening"
};
